import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ROUTES from "../../router/routesModel";

/**
 * Matches Supabase "Authorization path" (e.g. /oauth/consent) for OAuth Apps.
 * Normal email/Google sign-in uses /auth/callback instead.
 */
const OAuthConsentPage = () => {
  const navigate = useNavigate();

  return (
    // Literal px, not a `maxWidth` token (#211): /oauth/consent is an
    // AUTH_ROUTE (layout/chromeRoutes.js), so Layout renders it bare and its
    // 520px shell never reaches it. `maxWidth="sm"` could not stand in —
    // styles/theme.js:30-32 sets `sm: 100000`, so MUI compiled the clamp into
    // `@media (min-width:100000px)`, which no viewport matches. 520 matches
    // Layout.jsx:85. Do NOT repair the breakpoints instead — see [#208].
    <Container maxWidth={false} sx={{ maxWidth: 520, mx: "auto" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70vh",
          textAlign: "center",
          gap: 2,
        }}
      >
        <VpnKeyIcon sx={{ fontSize: 72, color: "primary.main", opacity: 0.9 }} />
        <Typography variant="h5" color="text.primary" fontWeight={700}>
          Sign in to Tradeloft
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
          Everyday login and Google sign-in go through the login page; after OAuth,
          Supabase returns you to <strong>/auth/callback</strong>. This URL is only for
          advanced OAuth App flows in the Supabase dashboard.
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, justifyContent: "center", mt: 1 }}>
          <Button variant="contained" size="large" onClick={() => navigate(ROUTES.LOGIN)}>
            Go to login
          </Button>
          <Button variant="outlined" size="large" onClick={() => navigate(ROUTES.ROOT)}>
            Homepage
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default OAuthConsentPage;
